import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { ChatWidget } from "@/components/ChatWidget";
import { useAuth } from "@/context/AuthContext";

export default function DashboardLayout() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const platforms = user?.platforms || [];
    if (!platforms.length) return;
    // Single-platform users landing on the app root go straight to their platform's home.
    if (location.pathname === "/app" && !platforms.includes("copilot360") && platforms.includes("soysos")) {
      navigate("/app/soysos", { replace: true });
    }
  }, [user, location.pathname, navigate]);

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 min-w-0 max-w-[1500px]">
        <Outlet />
      </main>
      <ChatWidget />
    </div>
  );
}
